import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent } from '../button';

@Component({
  selector: 'mbs-copy-button',
  templateUrl: './copy-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, I18NextPipe, NgbTooltip]
})
export class CopyButtonComponent {
  protected readonly copied = signal(false);
  protected readonly loading = signal(false);

  public readonly disabled = input<boolean>(false);
  public readonly isCtrl = input<boolean>(false);

  protected readonly mbsClipboard = output<void>();

  #animationInProgress = false;

  private async triggerAnimation(): Promise<void> {
    if (this.#animationInProgress) return;

    this.#animationInProgress = true;

    this.loading.set(true);
    await this.delay(250);

    this.loading.set(false);
    this.copied.set(true);
    await this.delay(1000);

    this.copied.set(false);

    this.#animationInProgress = false;
  }

  private delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  handleCopy(): void {
    this.mbsClipboard.emit();
    void this.triggerAnimation();
  }
}
